import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  getConnectConflicts,
  getConnectStatus,
  resolveConnectConflict,
} from './connect-api';
import type {
  ConnectConflictListResponse,
  ConnectStatus,
  ResolveConnectConflictPayload,
} from './types';

export const connectKeys = {
  all: ['connect'] as const,
  status: () => [...connectKeys.all, 'status'] as const,
  conflicts: () => [...connectKeys.all, 'conflicts'] as const,
};

export function useConnectStatus() {
  return useQuery<ConnectStatus>({
    queryKey: connectKeys.status(),
    queryFn: getConnectStatus,
    staleTime: 60_000,
  });
}

export function useConnectConflicts() {
  return useQuery<ConnectConflictListResponse>({
    queryKey: connectKeys.conflicts(),
    queryFn: getConnectConflicts,
    staleTime: 30_000,
  });
}

export function useResolveConnectConflict() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      conflictId,
      payload,
    }: {
      conflictId: string;
      payload: ResolveConnectConflictPayload;
    }) => resolveConnectConflict(conflictId, payload),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: connectKeys.conflicts() });
    },
  });
}
